import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import dayjs from 'dayjs'

import { Select } from '@st-operations/uikit/src/v2'
import { logErrorAsync } from '_lib/utility.js'

import { Block } from '.'
import IconAudience from './icons/icon-audience'
import IconAnalytics from './icons/icon-analytics'
import IconDataFeeds from './icons/icon-data-feeds'
import { STATUSES } from '../audience-creator/components/header'

import { getRecentAudiences, getEnumAudiences } from '_services/dashboard'

const getAudiences = async (status, creator) => {
  try {
    const audiences = await getRecentAudiences(status, creator)
    return audiences.items
  } catch (error) {
    logErrorAsync(error)
    return []
  }
}

const getUsers = async () => {
  try {
    return await getEnumAudiences()
  } catch (error) {
    logErrorAsync(error)
  }
}

const Card = ({ audience }) => {
  const { name, updatedAt, status, _id } = audience
  return (
    <div className="ac-card">
      <IconAudience size="30px" fill="#13682B" />
      <div className="ac-card__meta">
        <Link to={`/audience-creator/${_id}`}>{name.split('>').at(-1).trim()}</Link>
        <span>{dayjs(updatedAt).format('YYYY-MM-DD - HH:MM')}</span>
      </div>
      <div className="ac-card__status">{status}</div>
      <hr />
      <Link to={`/audience/${_id}/insights`} title="Open Insights">
        <IconAnalytics size="24px" fill="#13682B" />
      </Link>
      <hr />
      <Link to={`/data-explorer/discovery?audience_id=${_id}`} title="Open Data Feed">
        <IconDataFeeds size="24px" fill="#13682B" />
      </Link>
    </div>
  )
}

const AudienceCreatorBlock = ({ currentUser }) => {
  const [loading, setLoading] = useState(true)
  const [audiences, setAudiences] = useState([])
  const [users, setUsers] = useState([])
  const [user, setUser] = useState(currentUser)
  const [status, setStatus] = useState('')

  useEffect(() => {
    setLoading(true)
    getAudiences(status?.toLowerCase(), user).then((audiences) => {
      setAudiences(audiences)
      setLoading(false)
    })
  }, [status, user])

  useEffect(() => {
    getUsers().then(setUsers)
  }, [])

  return (
    <Block
      title="Audience Creator"
      link="/audience-creator"
      actions={
        <>
          <Select
            name="created_by"
            placeholder="All users"
            options={users}
            value={user}
            onChange={(_, _2, user) => setUser(user)}
            useReactSelect={true}
            isSearchable={true}
            isClearable={true}
          />
          <Select
            name="status"
            placeholder="Select a status"
            options={STATUSES}
            value={status}
            onChange={(_, _2, status) => setStatus(status)}
            useReactSelect={true}
            isSearchable={true}
            isClearable={true}
          />
        </>
      }
      content={
        loading ? (
          <p className="dashboard__zero-state-message">Loading...</p>
        ) : audiences.length ? (
          audiences.map((audience) => <Card key={audience.name} audience={audience} />)
        ) : (
          <p className="dashboard__zero-state-message">No entries</p>
        )
      }
    />
  )
}

export default AudienceCreatorBlock
